const { isANumber } = window.BAO.Utils
export class ProductLowStock extends window.BAO.CustomElement() {
  static get observedAttributes () {
    return ['available', 'inventory-policy', 'inventory-quantity', 'threshold']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  attributeChangedCallback (name, oldValue, newValue) {
    switch (name) {
      case 'available': {
        this.setVisibility(this.currentInventoryQuantity, this.currentThreshold)
        break
      }
      case 'inventory-policy': {
        this.setVisibility(this.currentInventoryQuantity, this.currentThreshold)
        break
      }
      case 'inventory-quantity': {
        if (!isANumber(newValue)) break
        if (parseInt(oldValue, 10) === parseInt(newValue, 10)) break

        this.handleInventoryQuantityUpdateSideEffects(parseInt(newValue, 10))

        break
      }
      case 'threshold': {
        if (!isANumber(newValue)) break
        if (parseInt(oldValue, 10) === parseInt(newValue, 10)) break

        this.handleThresholdUpdateSideEffects(parseInt(newValue, 10))

        break
      }
    }
  }

  setupListeners () {
    super.setupListeners()

    if (
      !this.hasAttribute('inventory-quantity') ||
      !this.hasAttribute('threshold') ||
      !this.parentEl
    ) {
      return
    }

    this.onVariantChange = this.onVariantChange.bind(this)

    this.listeners.add(
      this.parentEl,
      window.BAO.EVENTS.VARIANT.CHANGE,
      this.onVariantChange,
    )
  }

  /**
   * @param {Event} event
   *
   * @returns {void}
   */
  onVariantChange (event) {
    if (!event?.detail?.inventory?.id) return
    this.currentInventoryQuantity = event.detail.inventory.inventory_quantity
    this.currentInventoryPolicy = event.detail.inventory.inventory_policy
    this.isAvailable =
      String(event.detail.inventory.available).toLowerCase() === 'true'
  }

  /**
   * @param {Number} inventoryQuantity
   *
   * @returns {void}
   */
  handleInventoryQuantityUpdateSideEffects (inventoryQuantity) {
    this.setVisibility(inventoryQuantity, this.currentThreshold)
  }

  /**
   * @param {Number} threshold
   *
   * @returns {void}
   */
  handleThresholdUpdateSideEffects (threshold) {
    this.setVisibility(this.currentInventoryQuantity, threshold)
  }

  /**
   * @param {Number} inventoryQuantity
   * @param {Number} threshold
   *
   * @returns {void}
   */
  setVisibility (
    inventoryQuantity = this.currentInventoryQuantity,
    threshold = this.currentThreshold,
  ) {
    this.setAttribute(
      'aria-hidden',
      String(this.isHiddenByDefault || inventoryQuantity > threshold),
    )
  }

  /**
   * @returns {Boolean}
   */
  get isAvailable () {
    return this.getAttribute('available') === 'true'
  }

  /**
   * @returns {String} continue|deny
   */
  get currentInventoryPolicy () {
    return this.getAttribute('inventory-policy')
  }

  /**
   * @returns {Number}
   */
  get currentThreshold () {
    return parseInt(this.getAttribute('threshold'), 10)
  }

  /**
   * @returns {Number}
   */
  get currentInventoryQuantity () {
    return parseInt(this.getAttribute('inventory-quantity'), 10)
  }

  /**
   * @param {Boolean} available
   *
   * @returns {void}
   */
  set isAvailable (isAvailable) {
    this.setAttribute('available', String(isAvailable))
  }

  /**
   * @param {String} continue|deny
   *
   * @returns {void}
   */
  set currentInventoryPolicy (inventoryPolicy) {
    return this.setAttribute('inventory-policy', inventoryPolicy)
  }

  /**
   * @param {Number} threshold
   *
   * @returns {void}
   */
  set currentThreshold (threshold) {
    this.setAttribute('threshold', String(threshold))
  }

  /**
   * @param {Number} inventoryQuantity
   *
   * @returns {void}
   */
  set currentInventoryQuantity (inventoryQuantity) {
    this.setAttribute('inventory-quantity', String(inventoryQuantity))
  }

  /**
   * @returns {Boolean}
   */
  get isHiddenByDefault () {
    return !this.isAvailable || this.currentInventoryPolicy === 'continue'
  }

  /**
   * @returns {HTMLElement|null}
   */
  get parentEl () {
    return this.parentSelector
      ? this.closest(this.parentSelector)
      : this.closest('div')
  }

  /**
   * @returns {String|undefined}
   */
  get parentSelector () {
    return this.dataset?.parentSelector
  }
}

if (!customElements.get('product-low-stock')) {
  customElements.define('product-low-stock', ProductLowStock)
}
